export default {
  Codigo: null,
  Descripcion: '',
  Ingreso: false,
  Egreso: null,
  Transferencia: false,
  Autonumerico: null,
  ProximoNumero: null,
  Prefijo: null,
};
